/**
 * Prefer server-provided message from `ResponseError.body` and common JSON shapes.
 * @param {unknown} err
 * @returns {string|null}
 */
export function messageFromApiError(err) {
  if (!err) {
    return null
  }
  const body = err.body
  if (body == null) {
    return typeof err.message === 'string' && err.message.trim() ? err.message.trim() : null
  }
  if (typeof body === 'string') {
    const t = body.trim()
    return t || null
  }
  if (typeof body !== 'object') {
    return null
  }
  const pick = v => (typeof v === 'string' && v.trim() ? v.trim() : null)
  if (pick(body.message)) {
    return pick(body.message)
  }
  if (pick(body.detail)) {
    return pick(body.detail)
  }
  if (typeof body.error === 'string' && pick(body.error)) {
    return pick(body.error)
  }
  if (body.error && typeof body.error === 'object' && pick(body.error.message)) {
    return pick(body.error.message)
  }
  if (Array.isArray(body.errors) && body.errors.length) {
    const first = body.errors[0]
    if (typeof first === 'string' && pick(first)) {
      return pick(first)
    }
    if (first && pick(first.message)) {
      return pick(first.message)
    }
  }
  if (pick(body.title)) {
    return pick(body.title)
  }
  return null
}
